import { Footer } from './Footer';
import { InfoBlock as InfoBlockComponent } from './InfoBlock';
export const InfoBlock = InfoBlockComponent;
InfoBlock.Footer = Footer;
